<ion-app>
  <ion-router-outlet [animated]="false"></ion-router-outlet>
  <ion-backdrop *ngIf="!networkStatus" [class.noInternetBackdrop]="!networkStatus">
  </ion-backdrop>
</ion-app>